<template>
  <div class="mt-2">
    <icon-view
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-book-user text-orange"
      title="Información de Taller"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row mb-5">
      <div class="col-12 col-md-2">
        <ValidationProvider
          name="workshopDuration"
          v-slot="{ errors }"
          rules="required|min_value:0"
        >
          <custom-input
            label="Duración del Taller:"
            type="Number"
            :error="errors[0]"
            :disabled="readOnly"
            v-model="model.workshopDuration"
            custom-error-msg="Campo requerido y mayor de 0"
            :min="0"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-2">
        <span class="data-title d-block mb-2">
          Comienzo Inscripción:
        </span>
        <custom-date-picker
          v-model="model.start.date"
          placeholder="DD/MM/YYYY"
          class="custom-date-picker__extended"
          :disabled="readOnly || !enrollmentLimit?.date"
          :max-date="enrollmentLimit?.date"
        />
      </div>
      <div class="col-12 col-md-3">
        <span class="color-gray-6 font-14 font-weight-normal">
          Hora de Comienzo:
        </span>
        <validation-observer ref="startHourForm" v-slot="{ errors }">
          <div class="row pl-3 mt-2 div-time">
            <div class="col px-0">
              <validation-provider
                name="hour"
                :rules="{
                  numeric: true,
                  required: hasStartTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.start.hour"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.hour?.length,
                  }"
                  @input="onChangeTime"
                  :disabled="readOnly"
                />
              </validation-provider>
            </div>
            <div class="col-0 px-1 pt-1">
              :
            </div>
            <div class="col px-0 mr-2">
              <validation-provider
                name="minute"
                :rules="{
                  numeric: true,
                  required: hasStartTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.start.minute"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.minute?.length,
                  }"
                  :disabled="readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="px-0 calendar-available-space-select">
              <validation-provider
                name="type"
                :rules="{
                  required: hasStartTime,
                }"
              >
                <select
                  id="start"
                  v-model="model.start.type"
                  class="form-control"
                  :disabled="readOnly"
                  :class="{
                    'border border-danger rounded': errors.type?.length,
                  }"
                  @change="onChangeTime"
                >
                  <option :value="null"></option>
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="row py-0 my-0">
            <div
              v-for="(error, key) in errors"
              :key="key"
              class="col-12 py-0 my-0 text-danger"
            >
              <span v-if="error[0] === 'Campo Requerido'">
                El campo {{ parseErrorMessage(key) }} es requerido.
              </span>
              <span v-else>{{ parseErrorMessage(error[0]) }}</span>
            </div>
          </div>
        </validation-observer>
      </div>
      <div class="col-12 col-md-2">
        <span class="data-title d-block mb-2">
          Fecha Límite de Inscripción:
        </span>
        <custom-date-picker
          v-model="model.end.date"
          placeholder="DD/MM/YYYY"
          class="custom-date-picker__extended"
          :disabled="readOnly || !model?.start?.date"
          :max-date="enrollmentLimit?.date"
          :min-date="model?.start?.date"
        />
      </div>
      <div class="col-12 col-md-3">
        <span class="color-gray-6 font-14 font-weight-normal">
          Hora Límite:
        </span>
        <validation-observer ref="endHourForm" v-slot="{ errors }">
          <div class="row pl-3 mt-2 div-time mr-0">
            <div class="col px-0">
              <validation-provider
                name="hour"
                :rules="{
                  numeric: true,
                  required: hasEndTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.end.hour"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded':
                      errors.hour?.length ||
                      (isStartGreaterThanEnd && validated) ||
                      (isStartEqualToEnd && validated),
                  }"
                  :disabled="readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="col-0 px-1 pt-1">
              :
            </div>
            <div class="col px-0 mr-2">
              <validation-provider
                name="minute"
                :rules="{
                  numeric: true,
                  required: hasEndTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.end.minute"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded':
                      errors.minute?.length ||
                      (isStartGreaterThanEnd && validated) ||
                      (isStartEqualToEnd && validated),
                  }"
                  :disabled="readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="px-0 calendar-available-space-select">
              <validation-provider
                name="type"
                :rules="{
                  required: hasEndTime,
                }"
              >
                <select
                  id="end"
                  v-model="model.end.type"
                  class="form-control"
                  :class="{
                    'border border-danger rounded':
                      errors.type?.length ||
                      (isStartGreaterThanEnd && validated) ||
                      (isStartEqualToEnd && validated),
                  }"
                  :required="hasEndTime"
                  :disabled="readOnly"
                  @change="onChangeTime"
                >
                  <option :value="null"></option>
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="row py-0 my-0">
            <div
              v-for="(error, key) in errors"
              :key="key"
              class="col-12 py-0 my-0 text-danger"
            >
              <span v-if="error[0] === 'Campo Requerido'">
                El campo {{ parseErrorMessage(key) }} es requerido.
              </span>
              <span v-else>{{ parseErrorMessage(error[0]) }}</span>
            </div>
            <div
              v-if="validated && isStartGreaterThanEnd"
              class="col-12 py-0 my-0 text-danger"
            >
              <span>
                La hora de finalización no puede ser menor a la hora de
                comienzo.
              </span>
            </div>
            <div
              v-if="validated && isLimitHourAfterFinalization"
              class="col-12 py-0 my-0 text-danger"
            >
              <span>
                La hora de finalización no puede ser mayor a la hora límite.
              </span>
            </div>
            <div
              v-if="validated && isStartEqualToEnd"
              class="col-12 py-0 my-0 text-danger"
            >
              <span>
                La hora de finalización no puede ser igual a la hora de
                comienzo.
              </span>
            </div>
          </div>
        </validation-observer>
      </div>
      <div class="col-12 col-md-2 mt-4">
        <span class="data-title d-block mb-2">
          Fecha Cierre del Examen:
        </span>
        <custom-date-picker
          v-model="model.examClosingDate.date"
          placeholder="DD/MM/YYYY"
          class="custom-date-picker__extended"
          :disabled="readOnly"
          :min-date="model.start?.date"
        />
      </div>
      <div class="col-12 col-md-3 mt-4">
        <span class="color-gray-6 font-14 font-weight-normal">
          Hora de Cierre del Examen:
        </span>
        <validation-observer ref="startHourForm" v-slot="{ errors }">
          <div class="row pl-3 mt-2 div-time">
            <div class="col px-0">
              <validation-provider
                name="hour"
                :rules="{
                  numeric: true,
                  required: hasExamClosingDateTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.examClosingDate.hour"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.hour?.length,
                  }"
                  :disabled="readOnly"
                />
              </validation-provider>
            </div>
            <div class="col-0 px-1 pt-1">
              :
            </div>
            <div class="col px-0 mr-2">
              <validation-provider
                name="minute"
                :rules="{
                  numeric: true,
                  required: hasExamClosingDateTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.examClosingDate.minute"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.minute?.length,
                  }"
                  :disabled="readOnly"
                />
              </validation-provider>
            </div>
            <div class="px-0 calendar-available-space-select">
              <validation-provider
                name="type"
                :rules="{
                  required: hasExamClosingDateTime,
                }"
              >
                <select
                  id="start"
                  v-model="model.examClosingDate.type"
                  class="form-control"
                  :disabled="readOnly"
                  :class="{
                    'border border-danger rounded': errors.type?.length,
                  }"
                >
                  <option :value="null"></option>
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="row py-0 my-0">
            <div
              v-for="(error, key) in errors"
              :key="key"
              class="col-12 py-0 my-0 text-danger"
            >
              <span v-if="error[0] === 'Campo Requerido'">
                El campo {{ parseErrorMessage(key) }} es requerido.
              </span>
              <span v-else>{{ parseErrorMessage(error[0]) }}</span>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
    <div class="row my-3">
      <div class="row col-12 pr-0 ">
        <div class="col-7 col-sm-10 d-flex align-items-end pr-0  pl-0">
          <label>
            <span class="bg-orange px-2 py-1 color-white radius-5 mr-2">1</span>
            ¿Este taller tiene créditos para educación continua?
          </label>
        </div>
        <!-- Checkbox "Sí" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center custom-space p-2"
          :class="{
            'bg-success text-white': model.hasCredits,
            'bg-light text-muted': model.hasCredits === false,
          }"
        >
          <input
            type="checkbox"
            id="yes-checkbox"
            class="mb-1 custom-checkbox "
            :checked="model.hasCredits"
            :disabled="readOnly"
            @change="model.hasCredits = true"
          />
          <label for="yes-checkbox">Sí</label>
        </div>
        <!-- Checkbox "No" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center p-2"
          :class="{
            'bg-success text-white': model.hasCredits === false,
            'bg-light text-muted': model.hasCredits,
          }"
        >
          <input
            type="checkbox"
            id="no-checkbox"
            class="mb-1 custom-checkbox"
            :checked="model.hasCredits === false"
            :disabled="readOnly"
            @change="model.hasCredits = false"
          />
          <label for="no-checkbox">No</label>
        </div>
        <div class="w-100 border"></div>
        <custom-error
          v-if="showCheckValidations && model.hasCredits === null"
          message="El campo es requerido."
          variant="no-border mt-1"
        />
      </div>
    </div>
    <div v-if="model.hasCredits" class="row">
      <div class="col-12 col-md-3">
        <ValidationProvider
          v-slot="{ errors }"
          name="creditAmount"
          rules="required|min_value:1"
        >
          <custom-input
            v-model="model.creditAmount"
            :min="1"
            type="number"
            label="Cantidad de Créditos:"
            :error="errors[0]"
            custom-error-msg="Campo requerido y mayor de 0"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-9">
        <span class="data-title d-block mb-2">
          Fecha Límite para Remidir Créditos:
        </span>
        <ValidationProvider
          v-slot="{ errors }"
          name="creditSubmissionDeadline"
          rules="required"
        >
          <custom-date-picker
            v-model="model.creditSubmissionDeadline"
            placeholder="DD/MM/YYYY"
            :error="errors[0]"
            custom-error-msg="Campo requerido."
            container-class="w-100"
            :min-date="minDate"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row my-3">
      <div class="row col-12 pr-0 ">
        <div class="col-7 col-sm-10 d-flex align-items-end pr-0  pl-0">
          <label>
            <span class="bg-orange px-2 py-1 color-white radius-5 mr-2">2</span>
            ¿Va a tener Límite de Cupo?
          </label>
        </div>
        <!-- Checkbox "Sí" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center custom-space p-2"
          :class="{
            'bg-success text-white': model.willQuotaLimit,
            'bg-light text-muted': model.willQuotaLimit === false,
          }"
        >
          <input
            type="checkbox"
            id="yes-checkbox"
            class="mb-1 custom-checkbox "
            :checked="model.willQuotaLimit"
            :disabled="readOnly"
            @change="model.willQuotaLimit = true"
          />
          <label for="yes-checkbox">Sí</label>
        </div>
        <!-- Checkbox "No" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center p-2"
          :class="{
            'bg-success text-white': model.willQuotaLimit === false,
            'bg-light text-muted': model.willQuotaLimit,
          }"
        >
          <input
            type="checkbox"
            id="no-checkbox"
            class="mb-1 custom-checkbox"
            :checked="model.willQuotaLimit === false"
            :disabled="readOnly"
            @change="model.willQuotaLimit = false"
          />
          <label for="no-checkbox">No</label>
        </div>
        <div class="w-100 border"></div>
        <custom-error
          v-if="showCheckValidations && model.willQuotaLimit === null"
          message="El campo es requerido."
          variant="no-border mt-1"
        />
      </div>
    </div>
    <div v-if="model.willQuotaLimit" class="row">
      <div class="col-12 col-md-3">
        <ValidationProvider
          v-slot="{ errors }"
          name="quotaLimit"
          rules="required|min_value:1"
        >
          <custom-input
            v-model="model.quotaLimit"
            :min="1"
            type="number"
            label="Límite de Cupo:"
            :error="errors[0]"
            :disabled="readOnly"
            custom-error-msg="Campo requerido y mayor de 0"
          />
        </ValidationProvider>
      </div>
    </div>
    <div v-if="hasPostId" class="row my-3">
      <div class="row col-12 pr-0 ">
        <div class="col-7 col-sm-10 d-flex align-items-end pr-0 pl-0">
          <label>
            <span class="bg-orange px-2 py-1 color-white radius-5 mr-2">3</span>
            ¿Este taller va a tener Pre Prueba y Post Prueba?
          </label>
        </div>
        <!-- Checkbox "Sí" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center custom-space p-2"
          :class="{
            'bg-success text-white': model.prePostTest,
            'bg-light text-muted': model.prePostTest === false,
          }"
        >
          <input
            type="checkbox"
            id="yes-checkbox"
            class="mb-1 custom-checkbox "
            :checked="model.prePostTest"
            :disabled="readOnly"
            @change="model.prePostTest = true"
          />
          <label for="yes-checkbox">Sí</label>
        </div>
        <!-- Checkbox "No" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center p-2"
          :class="{
            'bg-success text-white': model.prePostTest === false,
            'bg-light text-muted': model.prePostTest,
          }"
        >
          <input
            type="checkbox"
            id="no-checkbox"
            class="mb-1 custom-checkbox"
            :checked="model.prePostTest === false"
            :disabled="readOnly"
            @change="model.prePostTest = false"
            @input="removeAllPreOrPostTest"
          />
          <label for="no-checkbox">No</label>
        </div>
        <div class="w-100 border"></div>
        <custom-error
          v-if="showCheckValidations && model.prePostTest === null"
          message="El campo es requerido."
          variant="no-border mt-1"
        />
      </div>
    </div>
    <div v-if="model.prePostTest">
      <workshop-configure-test-form
        is-pre-or-post-test
        :read-only="readOnly"
        :post-id="postId"
        :workshop-id="model.id"
        :classification-id="questionnaireClassificationType.PreTest"
        @partial-update="onPartialUpdate"
        @test-loaded="onLoadTest"
      />
    </div>
    <div class="row my-3" v-if="hasPostId">
      <div class="row col-12 pr-0 ">
        <div class="col-7 col-sm-10 d-flex align-items-end pr-0 pl-0">
          <label>
            <span class="bg-orange px-2 py-1 color-white radius-5 mr-2">4</span>
            ¿Este taller va a generar certificado?
          </label>
        </div>
        <!-- Checkbox "Sí" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center custom-space p-2"
          :class="{
            'bg-success text-white': model.willGenerateCertificate,
            'bg-light text-muted': model.willGenerateCertificate === false,
          }"
        >
          <input
            type="checkbox"
            id="round-checkbox"
            class="mb-1 custom-checkbox "
            :checked="model.willGenerateCertificate"
            :disabled="readOnly"
            @change="model.willGenerateCertificate = true"
          />
          <label for="round-checkbox">Sí</label>
        </div>
        <!-- Checkbox "No" -->
        <div
          class="col-2 col-sm-1 border rounded-top d-flex flex-column align-items-center p-2"
          :class="{
            'bg-success text-white': model.willGenerateCertificate === false,
            'bg-light text-muted': model.willGenerateCertificate,
          }"
        >
          <input
            type="checkbox"
            id="no-checkbox"
            class="mb-1 custom-checkbox"
            :checked="model.willGenerateCertificate === false"
            :disabled="readOnly"
            @change="model.willGenerateCertificate = false"
            @input="removeAllExam"
          />
          <label for="round-checkbox">No</label>
        </div>
        <div class="w-100 border"></div>
        <custom-error
          v-if="showCheckValidations && model.willGenerateCertificate === null"
          message="El campo es requerido."
          variant="no-border mt-1"
        />
      </div>
    </div>
    <div v-if="model.willGenerateCertificate" class="row">
      <div class="col-12 col-md-3 mt-1 pl-0">
        <ValidationProvider
          v-slot="{ errors }"
          name="authMethod"
          rules="required"
        >
          <custom-radio
            label="Mecanismo de Autenticación:"
            is-inline
            :value="model.auth.methodId?.toString()"
            :options="authOptions"
            :error="errors[0]"
            custom-error-msg="Campo requerido."
            :is-disabled="readOnly"
            @input="onChangeMethod"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-3" v-if="isCodeInputVisible">
        <ValidationProvider
          name="authCode"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            label="Ingresar el Código:"
            type="text"
            v-model="model.auth.code"
            :error="errors[0]"
            custom-error-msg="Campo requerido."
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
    </div>
    <div v-if="model.willGenerateCertificate && isTestInputVisible">
      <workshop-configure-test-form
        :workshop-id="model.id"
        :read-only="readOnly && hasParticipantWithExam"
        :post-id="postId"
        :classification-id="questionnaireClassificationType.Exam"
        @partial-update="onPartialUpdate"
        @test-loaded="onLoadTest"
      />
    </div>
  </div>
</template>

<script>
import WorkshopConfigureTestForm from './WorkshopConfigureTestForm';
import IconView from 'icon-view';
import CustomRadio from 'custom-radio';
import CustomInput from 'CustomInput';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomTimePicker from 'custom-time-picker';
import {
  getAuthenticationMechanismTypes,
  removeQuestionnaire,
} from '@/services/operations/dashboard-management';
import AUTH_METHODS from '@/utils/constants/operations-dashboard-management/authMethods';
import QuestionnaireClassificationType from '@/utils/constants/operations-dashboard-management/QuestionnaireClassificationType';
import moment from 'moment';
import CustomError from 'custom-error';

const format = 'h:mm A';

export default {
  name: 'WorkshopInfo',
  components: {
    WorkshopConfigureTestForm,
    CustomRadio,
    IconView,
    CustomInput,
    CustomDatePicker,
    CustomTimePicker,
    CustomError,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    postId: {
      type: Number,
      default: () => 0,
    },
    enrollmentLimit: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      showCheckValidations: false,
      authOptions: [],
      validated: false,
      questionnaireClassificationType: QuestionnaireClassificationType,
    };
  },
  async mounted() {
    await this.getAuthTypes();
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasPostId() {
      return Boolean(this.postId);
    },
    minDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    isCodeInputVisible() {
      return this.model.auth.methodId == AUTH_METHODS.Code;
    },
    isTestInputVisible() {
      return this.model.auth.methodId == AUTH_METHODS.Exam;
    },
    hasParticipantWithExam() {
      return this.model.hasParticipantWithExam;
    },
    hasStartTime() {
      return (
        !!this.model.start.hour ||
        !!this.model.start.minute ||
        !!this.model.start.type
      );
    },
    hasEndTime() {
      return (
        !!this.model.end.hour ||
        !!this.model.end.minute ||
        !!this.model.end.type
      );
    },
    hasExamClosingDateTime() {
      return (
        !!this.model.examClosingDate.hour ||
        !!this.model.examClosingDate.minute ||
        !!this.model.examClosingDate.type
      );
    },
    isStartGreaterThanEnd() {
      return !this.hasStartTime && !this.hasEndTime
        ? moment(this.model?.start?.date).isAfter(moment(this.model.end.date))
        : this.startHourValue.isAfter(this.endHourValue);
    },
    isStartEqualToEnd() {
      return this.startHourValue.format() === this.endHourValue.format();
    },
    startHourValue() {
      const { hour, minute, type } = this.model.start;
      const date = moment(this.model?.start?.date);
      const time = `${hour}:${minute} ${type}`;
      const start = moment(time, format);

      date.set({
        hour: start.get('hour'),
        minute: start.get('minute'),
        second: start.get('second'),
      });

      return date;
    },
    endHourValue() {
      const { hour, minute, type } = this.model.end;
      const date = moment(this.model?.end?.date);
      const time = `${hour}:${minute} ${type}`;
      const end = moment(time, format);

      date.set({
        hour: end.get('hour'),
        minute: end.get('minute'),
        second: end.get('second'),
      });

      return date;
    },
    endHourValueFromGeneralInfo() {
      const { hour, minute, type } = this.enrollmentLimit;
      const date = moment(this.enrollmentLimit.date);
      const time = `${hour}:${minute} ${type}`;
      const end = moment(time, format);

      date.set({
        hour: end.get('hour'),
        minute: end.get('minute'),
        second: end.get('second'),
      });
      return date;
    },
    isLimitHourAfterFinalization() {
      const finalDate = this.endHourValueFromGeneralInfo;
      const limitDate = this.endHourValue;

      const sameDay = finalDate.isSame(limitDate, 'day');
      if (!sameDay) return false;

      // Extrae horas como minutos desde la medianoche
      const finalHourMinutes = finalDate.hours() * 60 + finalDate.minutes();
      const limitHourMinutes = limitDate.hours() * 60 + limitDate.minutes();

      return limitHourMinutes > finalHourMinutes;
    },
  },
  methods: {
    onPartialUpdate(resolve) {
      this.$emit('partial-update', resolve);
    },
    hasValidChecks() {
      const isValid =
        this.model.willQuotaLimit != null &&
        this.model.hasCredits != null &&
        this.model.willGenerateCertificate != null &&
        this.model.prePostTest != null;
      this.showCheckValidations = !isValid;

      return isValid;
    },
    async onChangeMethod(value) {
      this.model.auth.methodId = value ? Number(value) : null;
      this.model.auth.code = null;
      await this.removeAllExam();
    },
    async getAuthTypes() {
      const { data } = await getAuthenticationMechanismTypes();
      this.authOptions = data.map(({ id, name }) => ({
        value: `${id}`,
        label: name,
      }));
    },
    async onChangeTime() {
      if (!this.hasStartTime && !this.hasEndTime) {
        this.validated = true;
        return !this.isStartGreaterThanEnd;
      }

      const isValidStart = await this.$refs.startHourForm.validate();
      const isValidEnd = await this.$refs.endHourForm.validate();
      this.validated = isValidStart && isValidEnd;
      if (
        !this.validated ||
        this.isStartGreaterThanEnd ||
        this.isStartEqualToEnd ||
        this.isLimitHourAfterFinalization
      ) {
        return false;
      }

      return true;
    },
    parseErrorMessage(msg) {
      if (!msg) return '';
      return msg
        .replace('hour', 'hora')
        .replace('minute', 'minuto')
        .replace('type', 'campo');
    },
    async validate() {
      if (this.model?.start?.date || this.model?.end?.date)
        return await this.onChangeTime();

      return true;
    },
    async removeAllPreOrPostTest() {
      const payload = {
        postId: this.postId,
        isPreOrPostTest: true,
      };
      await removeQuestionnaire(payload);
    },
    async removeAllExam() {
      const payload = {
        postId: this.postId,
        isPreOrPostTest: false,
      };
      await removeQuestionnaire(payload);
    },
    onLoadTest(item) {
      if (!this.model.tests) this.model.tests = [];
      const exist = this.model.tests.some((x) => x.id === item.id);
      if (!exist) this.model.tests.push(item);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.fa-calendar-day) {
  font-weight: 400 !important;
}
::v-deep(.dot.text-center) {
  background-color: white !important;
}
::v-deep(.custom-datetime-picker-container.width-container) {
  width: 31.8% !important;
}
.custom-checkbox {
  appearance: none; /* Elimina el estilo predeterminado */
  width: 25px;
  height: 25px;
  border-radius: 50%; /* Hace que el checkbox sea circular */
  border: 2px solid #4caf50; /* Borde verde */
  background-color: white; /* Fondo blanco */
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  border-color: #d6d6d6; /* Borde verde cuando está marcado */
}

/* Estilo cuando el checkbox está marcado */
.custom-checkbox:checked {
  background-color: #30b484; /* Fondo verde cuando está marcado */
  border-color: #fff; /* Borde verde cuando está marcado */
}

/* Estilo para mostrar el checkmark */
.custom-checkbox:checked::after {
  content: '✔'; /* Checkmark */
  color: white;
  font-size: 14px;
  position: absolute;
  left: 5px;
}
.custom-space {
  right: 4px;
}

.custom-date-picker__extended ::v-deep {
  .custom-datetime-picker-container {
    width: 100% !important;
  }
}
.radius-5 {
  border-radius: 5px;
}
</style>
